/// <reference path="../../../../Modules/Attr/Grid/NoboxEntityGrid.ts" />
namespace Nobox {

    import fld = ChatroomagentsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class LinkAgentGrid extends NoboxEntityGrid<ChatroomagentsRow, any> {
        protected getColumnsKey() { return Chat.LinkAgentColumns.columnsKey; }
        protected getDialogType() { return ChatroomagentsDialog; }
        protected getIdProperty() { return ChatroomagentsRow.idProperty; }
        protected getInsertPermission() { return ChatroomagentsRow.insertPermission; }
        protected getLocalTextPrefix() { return ChatroomagentsRow.localTextPrefix; }
        protected getService() { return ChatroomagentsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected initEntityDialog(itemType, dialog) {
            super.initEntityDialog(itemType, dialog);
            Serenity.SubDialogHelper.cascade(dialog, this.element.closest('.ui-dialog'));
        }

        //protected addButtonClick() {
        //    this.editItem({ ListId: this.contactId });
        //}


        protected getPersistanceStorage(): Serenity.SettingStorage {
            return window.localStorage;
        }

        protected getButtons() {
            var buttons = super.getButtons();
            var $this = this;
            buttons.splice(0, 1);
            return buttons;
        }

        protected getInitialTitle() {
            return null;
        }

        protected getColumns(): Slick.Column[] {
            var columns = super.getColumns();
            let listChannel = Q.getLookup("Nobox.ChannelAutomationLookup").itemById as unknown as Master.ChannelRow[];

            Q.first(columns, x => x.field == ChatroomagentsRow.Fields.ChId).format =
                ctx => `<a href="javascript:;" class="channel-link" data-id="${ctx.item.ChId}">${Q.htmlEncode(listChannel[ctx.value] == undefined ? "" : listChannel[ctx.value].Nm)}</a>`;

            return columns;
        }

        protected getGridCanLoad() {
            return super.getGridCanLoad() && !!this.roomId;
        }
        private _RoomId: number;

        get roomId() {
            return this._RoomId;
        }
        protected onViewSubmit(): boolean {
            if (!super.onViewSubmit()) { return false; }
            let request = this.view.params as ChatroomagentsListRequest;
            var equalFilter = {} as ChatroomagentsRow;
            var rmId = this.roomId;
            if (rmId != undefined) {
                equalFilter.RoomId = rmId;
            }
            request.EqualityFilter = equalFilter; return true;
        }
        set roomId(value: number) {
            if (this._RoomId !== value) {
                this._RoomId = value;
                this.refresh();
            }
        }
        protected getViewOptions() {
            let opt = super.getViewOptions();
            opt.rowsPerPage = 20;
            opt.url = Q.resolveUrl('~/Services/' + this.getService() + '/List');
            return opt;
        }
        protected getPagerOptions() {
            let opt = super.getPagerOptions();
            opt.rowsPerPageOptions = [10, 20, 50, 100, 500, 1000];
            return opt;
        }
    }
}